import { createAction, props } from '@ngrx/store';
import { AccountTerminationStatus } from '../reducers/session-info.reducer';

export enum UserAccountActions {
  AccountTermination = '[User/Account] UserAccount termination changed',
}

export const AccountTerminationChanged = createAction(
  UserAccountActions.AccountTermination,
  props<{
    accountTerminationStatus: AccountTerminationStatus;
  }>(),
);
